module.exports = __webpack_public_path__ + "icon_hallintorakennus.ce0ab3095b0e9f3f3089.svg";